<template>
  <div>
    <v-card
      ><v-card-text>
        <menuSuperviseur />

        <v-card flat>
          <v-card-text>
            <v-card-actions>
              <v-container fluid>
                <v-row align="center">
                  <v-col class="my-0 py-0">
                    <v-autocomplete
                      @change="buildrequest(), setDistricts()"
                      v-model="regionSelected"
                      :items="regions"
                      outlined
                      dense
                      label="Régions"
                      item-text="ll_region"
                      item-value="id"
                      return-object
                      multiple
                      deletable-chips
                      small-chips
                      :rules="selectRules"
                    ></v-autocomplete>
                  </v-col>
                  <v-col class="my-0 py-0">
                    <v-autocomplete
                      @change="buildrequest()"
                      v-model="districtsSelected"
                      :items="districts"
                      outlined
                      dense
                      label="Districts"
                      item-text="ll_district"
                      item-value="id"
                      return-object
                      multiple
                      deletable-chips
                      small-chips
                      :rules="selectRules"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col class="my-0 py-0">
                    <v-autocomplete
                      @change="buildrequest()"
                      v-model="animateurSelected"
                      :items="animateursDeProjets"
                      outlined
                      dense
                      label="Animateurs"
                      item-text="displayName"
                      item-value="id"
                      deletable-chips
                      small-chips
                    ></v-autocomplete>
                  </v-col>
                  <v-col class="my-0 py-0">
                    <v-autocomplete
                      @change="buildrequest()"
                      v-model="projetSelected"
                      :items="projets"
                      outlined
                      dense
                      label="Projets"
                      item-text="ll_programme"
                      item-value="id"
                      deletable-chips
                      small-chips
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-right my-0 py-0">
                    <v-btn
                      class="blue mx-4"
                      dark
                      :loading="loadingMembre"
                      @click="GetMembresDeRegions()"
                    >
                      Afficher membres</v-btn
                    >
                    <v-btn
                      color="primary"
                      @click="GetGroupesDeRegions()"
                      :loading="loading"
                    >
                      Afficher Groupes
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-actions>

            <template>
              <v-card flat>
                <vue-excel-xlsx
                  class="mx-4"
                  :data="membres"
                  :columns="headersMembres"
                  :filename="'membres_' + Date.now()"
                  :sheetname="'membres'"
                >
                  <v-btn class="blue" dark>
                    <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                    Télécharger {{ membres.length }} membres</v-btn
                  >
                </vue-excel-xlsx>

                <vue-excel-xlsx
                  :data="groupes"
                  :columns="headers"
                  :filename="'groupes_' + Date.now()"
                  :sheetname="'groupes'"
                >
                  <v-btn class="primary">
                    <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                    Télécharger {{ groupes.length }} groupes</v-btn
                  >
                </vue-excel-xlsx>
                <v-tabs v-model="tab" class="elevation-0">
                  <v-tabs-slider></v-tabs-slider>

                  <v-tab href="#groupes">
                    Groupes
                  </v-tab>

                  <v-tab href="#membres">
                    Membres
                  </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                  <v-tab-item value="groupes">
                    <v-card flat>
                      <v-card-text>
                        <v-text-field
                          v-model="search"
                          append-icon="mdi-magnify"
                          label="Rechercher groupe"
                          single-line
                          hide-details
                        ></v-text-field>
                        <v-data-table
                          dense
                          :headers="headers"
                          :items="groupes"
                          :search="search"
                          locale="fr"
                          :item-class="row_classes"
                        >
                          <template v-slot:item.projets="{ item }">
                            <template>
                              <div v-if="item.projets">
                                <v-btn
                                  class="mx-2"
                                  fab
                                  dark
                                  x-small
                                  color="red"
                                  v-if="item.projets.length === 0"
                                >
                                  <v-icon>
                                    mdi-alert-circle-outline
                                  </v-icon>
                                </v-btn>

                                <ul v-else :class="redPink(item.projets)">
                                  <li
                                    v-for="(projets,
                                    indexprojets) in item.projets"
                                    :key="indexprojets"
                                  >
                                    {{ projets.ll_programme }} -
                                    {{ projets.abbr_bailleur }}
                                  </li>
                                </ul>
                              </div>
                            </template>
                          </template>

                          <template v-slot:item.actions="{ item }">
                            <div class="row" v-if="user.role == 'regionalFull'">
                              <div
                                class="col mx-0 px-0 py-1"
                                v-if="item.projets"
                              >
                                <v-tooltip
                                  bottom
                                  v-for="(projet, indexprojets) in item.projets"
                                  :key="indexprojets"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      v-bind="attrs"
                                      v-on="on"
                                      outlined
                                      rounded
                                      small
                                      dark
                                      class="success mr-2"
                                      @click="goTodetailsGroupe(item, projet)"
                                    >
                                      Projet {{ projet.ll_programme }}
                                      <v-icon>chevron_right</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Détails du groupe</span>
                                </v-tooltip>
                              </div>
                              <div class="col mx-0 px-0 py-1">
                                <DialogAssignGroupToUser
                                  :groupe="item"
                                  @reloadAfficher="GetGroupesDeRegions()"
                                />
                              </div>
                              <div class="col mx-0 px-0 py-1">
                                <DialogLinkGroupAndProjets
                                  :groupe="item"
                                  @reloadAfficher="GetGroupesDeRegions()"
                                />
                              </div>
                              <div class="col mx-0 px-0 py-1">
                                <!--     <v-tooltip bottom>
                                 <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      outlined
                                      x-small
                                      fab
                                      dark
                                      class="blue"
                                      v-on="on"
                                      @click="printFicheFormation(item)"
                                    >
                                      <v-icon>mdi-printer</v-icon>
                                    </v-btn>
                                  </template> 
                                  <span>Imprimer fiche de formation</span>
                                </v-tooltip>-->
                              </div>
                              <!--    <div class="col mx-0 px-0 py-1">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      outlined
                                      x-small
                                      fab
                                      dark
                                      class="info"
                                      v-on="on"
                                      @click="printFicheDotation(item)"
                                    >
                                      <v-icon>mdi-printer-settings</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Imprimer fiche de distribution</span>
                                </v-tooltip>
                              </div> -->
                              <div class="col mx-0 px-0 py-1">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      v-bind="attrs"
                                      v-on="on"
                                      outlined
                                      x-small
                                      fab
                                      dark
                                      class="danger"
                                      @click="deleteGroup(item)"
                                    >
                                      <v-icon>mdi-trash-can-outline</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Effacer groupe</span>
                                </v-tooltip>
                              </div>
                            </div>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="membres">
                    <v-card flat>
                      <v-card-text>
                        <v-text-field
                          v-model="searchMembres"
                          append-icon="mdi-magnify"
                          label="Rechercher membre"
                          single-line
                          hide-details
                        ></v-text-field>
                        <v-data-table
                          :headers="headersMembres"
                          :items="membres"
                          :search="searchMembres"
                          locale="fr"
                        >
                          <template v-slot:item.sexe="{ item }">
                            {{ getSexe(item.sexe) }}
                          </template>
                          <template v-slot:item.membre_gec="{ item }">
                            {{ formatGEC(item.membre_gec) }}
                          </template>
                          <template v-slot:item.actif_dans_groupe="{ item }">
                            {{ formatActif(item.actif_dans_groupe) }}
                          </template>
                          <template v-slot:item.hors_groupe="{ item }">
                            {{ formatHG(item.hors_groupe) }}
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-container
                              style="width: 320px;"
                              v-if="user.role == 'regionalFull'"
                            >
                              <v-row no-gutters>
                                <v-col class="mx-1" style="flex-grow: 0;">
                                  <v-btn
                                    @click.stop="detailsMembre(item)"
                                    outlined
                                    x-small
                                    fab
                                    dark
                                    class="success mr-2"
                                  >
                                    <v-icon>chevron_right</v-icon>
                                  </v-btn>
                                  <v-btn
                                    @click.stop="deleteMembre(item)"
                                    outlined
                                    x-small
                                    fab
                                    dark
                                    class="danger mr-2"
                                  >
                                    <v-icon>mdi-trash-can-outline</v-icon>
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-container>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-card>
            </template>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <Navigation :elements="SuperviseurNavigation" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import "firebase/firestore";
import VueJsonPretty from "vue-json-pretty";
import { mapState, mapActions } from "vuex";
//import 'vue-json-pretty/lib/styles.css'
export default {
  created() {
    let self = this;

    this.SetProjectList();
    this.getDetailsRegionsSupervisees(this.listeRegionsSupervisees);
    this.getAnimateurs(this.regionSupervisees);

    if (Object.keys(this.$route.params).length === 0) {
      console.log("pas de request", this.request);
    } else {
      this.request = this.$route.params;
      this.regionSelected = this.request.regions;
      this.districtsSelected = this.request.districts;
      this.projetSelected = this.request.projets;
      this.animateurSelected = this.request.animateurs;
      this.GetGroupesDeRegions();
    }
  },
  components: {
    VueJsonPretty,
    menuSuperviseur: require("@/components/superviseur/menuSuperviseur.vue")
      .default,
    Navigation: require("@/components/Navigation.vue").default,
    DialogLinkGroupAndProjets: require("@/components/DialogLinkGroupAndProjets.vue")
      .default,
    DialogAssignGroupToUser: require("@/components/superviseur/DialogAssignGroupToUser.vue")
      .default,
  },
  data() {
    return {
      infected: "Non",
      searchMembres: "",
      headersMembres: [
        {
          text: "Id",
          value: "id",
          label: "Id",
          field: "id",
        },
        {
          text: "Code Producteur",
          value: "codeProducteur",
          label: "Code Producteur",
          field: "codeProducteur",
        },
        {
          text: "Nom",
          value: "nom",
          label: "Nom",
          field: "nom",
        },
        {
          text: "Sexe",
          value: "sexe",
          label: "Sexe",
          field: "sexe",
          dataFormat: this.getSexe,
        },
        {
          text: "Code ménage",
          value: "code_menage",
          label: "Code ménage",
          field: "code_menage",
        },
        {
          text: "Année de naissance",
          value: "annee_naissance",
          label: "Année de naissance",
          field: "annee_naissance",
        },
        {
          text: "Membre GEC",
          label: "Membre GEC",
          value: "membre_gec",
          field: "membre_gec",
          dataFormat: this.formatGEC,
        },
        {
          text: "Actif",
          label: "Actif",
          value: "actif_dans_groupe",
          field: "actif_dans_groupe",
          dataFormat: this.formatActif,
        },
        {
          text: "Hors Groupe",
          label: "Hors Groupe",
          value: "hors_groupe",
          field: "hors_groupe",
          dataFormat: this.formatHG,
        },
        {
          text: "Nom du groupe",
          label: "Nom du groupe",
          value: "nom_groupe",
          field: "nom_groupe",
        },
        {
          text: "Id du groupe",
          label: "Id du groupe",
          value: "id_groupe",
          field: "id_groupe",
        },
        {
          text: "Animateur",
          label: "Animateur",
          value: "nom_responsable",
          field: "nom_responsable",
        },
        {
          text: "Région",
          value: "ll_region",
          label: "Région",
          field: "ll_region",
        },
        {
          text: "District",
          value: "ll_district",
          label: "District",
          field: "ll_district",
        },
        {
          text: "Commune",
          value: "ll_commune",
          label: "Commune",
          field: "ll_commune",
        },
        {
          text: "Fokontany",
          value: "ll_fokontany",
          label: "Fokontany",
          field: "ll_fokontany",
        },
        { text: "", value: "actions" },
      ],
      search: "",
      headers: [
        { text: "", value: "actions" },
        {
          text: "id",
          label: "id",
          value: "id",
          field: "id",
        },
        {
          text: "Groupe",
          label: "Groupe",
          value: "nom_groupe",
          field: "nom_groupe",
        },
        {
          text: "Date de constitution",
          label: "Date de constitution",
          value: "date_constitution",
          field: "date_constitution",
        },

        {
          text: "Projets",
          value: "projets",
          label: "Projets",
          field: "projets",
          dataFormat: this.projetFormat,
        },

        {
          text: "Animateur",
          value: "nom_responsable",
          label: "Animateur",
          field: "nom_responsable",
        },
        {
          text: "Région",
          value: "ll_region",
          label: "Région",
          field: "ll_region",
        },
        {
          text: "District",
          value: "ll_district",
          label: "District",
          field: "ll_district",
        },
        {
          text: "Commune",
          value: "ll_commune",
          label: "Commune",
          field: "ll_commune",
        },
        {
          text: "Fokontany",
          value: "ll_fokontany",
          label: "Fokontany",
          field: "ll_fokontany",
        },
      ],

      tab: "groupes",
      text: "Lorem ipsum dolor sit amet",
      selectRules: [(v) => !!v || "Veuillez sélectionner une valeur"],
      loading: false,
      loadingMembre: false,
      groupes: [],
      membres: [],
      request: { regions: [], districts: [], projets: [], animateurs: [] },
      regions: [],
      districts: [],
      regionSelected: [],
      projetSelected: null,
      animateurSelected: null,
      districtsSelected: [],
      arrayGroupes: [],
      ProjetctList: [],
    };
  },
  methods: {
    SetProjectList() {
      this.ProjetctList = Array.isArray(this.user.projets)
        ? this.user.projets.map((projet) => projet.id)
        : [];
    },

    row_classes(item) {
      if (item.menageGenerated) {
        return "ok";
      } else {
        return "pink lighten-5";
      }
    },
    formatActif(value) {
      if (value === 0) {
        return "Inactif";
      } else {
        return "Actif";
      }
    },
    formatGEC(value) {
      if (value === 1) {
        return "Oui";
      } else {
        return "Non";
      }
    },
    formatHG(value) {
      if (value === "1") {
        return "Oui";
      } else {
        return "Non";
      }
    },
    projetFormat(value) {
      var tab = [];
      value.forEach((item, index) => {
        tab[index] = item.ll_programme;
      });

      return `${tab.toString()}`;
    },
    redPink(projets) {
      if (projets.length === 0) {
        return "redPink";
      }
    },
    buildrequest() {
      this.request.regions = this.regionSelected;
      this.request.districts = this.districtsSelected;
      this.request.projets = this.projetSelected;
      this.request.animateurs = this.animateurSelected;
      console.log("request :", this.request);
    },

    setDistricts() {
      var self = this;
      this.districts = [];
      this.$firebase
        .firestore()
        .collection("districts")
        .where("regions_id_region", "in", self.regionSupervisees)
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var district = doc.data();
            //console.log(doc.data());
            district.id = doc.id;
            self.districts.push({
              ...district,
            });
            self.districtLoading = false;
          });
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
      console.log("districts :", this.districts);
    },
    getSexe(sexe) {
      if (sexe == "1") {
        return "Masculin";
      } else {
        return "Féminin";
      }
    },
    calculate_age(dob) {
      return this.$moment().diff(dob + "-01-01");
    },

    goTodetailsGroupe(item, projet) {
      this.$router.push({
        path: `/detailsGroupe/${item.id}`,
        query: { projet: projet.id },
      });
    },
    detailsMembre(item) {
      this.$router.push({
        path: `/membre/${item.id}`,
      });
    },
    deleteMembre(item) {
      let self = this;
      this.$confirm(
        "Voulez vous vraiment supprimer le  membre <strong>" +
          item.nom +
          "</strong>   et ses différentes activités?"
      ).then((res) => {
        if (res) {
          self.deleteMembreStore(item.id).then(() => {
            self.GetMembresDeRegions();
          });
        }
      });
    },

    ...mapActions({
      GetArrayRegions: "Utils/GetArrayRegions",
      deleteGroupeStore: "Groupes/deleteGroupe",
      deleteMembreStore: "Membres/deleteMembre",
      GetMembresDuGroupe: "Membres/GetMembresDuGroupe",
      SetItemById: "Groupes/SetItemById",
      getAnimateurs: "Users/getAnimateurs",
    }),
    async GetGroupesDeRegions() {
      let self = this;
      this.loading = true;

      /**** listeRegions */
      let listeRegionsString = [];
      _.forEach(self.request.regions, function (item, index) {
        listeRegionsString[index] = item.id;
      });
      let listeRegionsInteger = [];
      _.forEach(self.request.regions, function (item, index) {
        listeRegionsInteger[index] = parseInt(item.id);
      });
      let listeRegions = _.union(listeRegionsString, listeRegionsInteger);

      /**** End listeRegions */

      /**** listeDistricts */
      let listeDistrictsString = [];
      _.forEach(self.request.districts, function (item, index) {
        listeDistrictsString[index] = item.id;
      });
      let listeDistrictsInteger = [];
      _.forEach(self.request.districts, function (item, index) {
        listeDistrictsInteger[index] = parseInt(item.id);
      });
      let listeDistricts = _.union(listeDistrictsString, listeDistrictsInteger);

      /**** listeDistricts */
      let listeProjets = this.request.projets;

      let listeAnimateurs = this.request.animateurs;

      self.groupes = [];
      self.arrayGroupes = [];
      var groupesRef = this.$firebase.firestore().collection("groupes");
      let query = groupesRef.where("id_region", "==", 0);
      if (listeRegions.length > 0) {
        query = groupesRef.where("id_region", "in", listeRegions);
      }
      if (listeDistricts.length > 0) {
        query = groupesRef.where("id_district", "in", listeDistricts);
      }

      if (listeAnimateurs) {
        query = query.where("responsable", "==", listeAnimateurs);
        //console.log("listeAnimateurs :", listeAnimateurs)
      }

      if (listeProjets) {
        console.log("listeProjets:", listeProjets);
        self = this;
        query = query.where("projectList", "array-contains", listeProjets);
      }

      const results = await query
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            self.groupes.push({
              ...doc.data(),
              id: doc.id,
            });
            self.arrayGroupes.push(doc.id);
          });
          self.tab = "groupes";
          self.loading = false;
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },

    async GetMembresDeRegions() {
      let self = this;

      this.loadingMembre = true;
      /**** listeRegions */
      let listeRegionsString = [];
      _.forEach(self.request.regions, function (item, index) {
        listeRegionsString[index] = item.id;
      });
      let listeRegionsInteger = [];
      _.forEach(self.request.regions, function (item, index) {
        listeRegionsInteger[index] = parseInt(item.id);
      });
      let listeRegions = _.union(listeRegionsString, listeRegionsInteger);

      /**** End listeRegions */

      /**** listeDistricts */
      let listeDistrictsString = [];
      _.forEach(self.request.districts, function (item, index) {
        listeDistrictsString[index] = item.id;
      });
      let listeDistrictsInteger = [];
      _.forEach(self.request.districts, function (item, index) {
        listeDistrictsInteger[index] = parseInt(item.id);
      });
      let listeDistricts = _.union(listeDistrictsString, listeDistrictsInteger);

      /**** End listeDistricts */
      let listeProjets = this.request.projets;

      let listeAnimateurs = this.request.animateurs;

      self.membres = [];
      var membresRef = this.$firebase.firestore().collection("membres");
      let query = membresRef.where("id_region", "==", 0);
      if (listeRegions.length > 0) {
        query = membresRef.where("id_region", "in", listeRegions);
        console.log("listeRegions :", listeRegions);
      }
      if (listeDistricts.length > 0) {
        query = membresRef.where("id_district", "in", listeDistricts);
        console.log("listeDistricts :", listeDistricts);
      }

      if (listeAnimateurs) {
        query = query.where("id_responsable", "==", listeAnimateurs);
        console.log("listeAnimateurs :", listeAnimateurs);
      }

      self.GetGroupesDeRegions().then(() => {
        let membresTemp = [];

        const results = query
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              membresTemp.push({
                ...doc.data(),
                id: doc.id,
              });
            });

            let output = _.filter(membresTemp, (v) =>
              _.includes(self.arrayGroupes, v.id_groupe)
            );

            self.membres = output;

            self.tab = "membres";
            self.loadingMembre = false;
          })
          .catch((error) => {
            console.log("Error getting documents: ", error);
          });
      });
    },

    getDetailsRegionsSupervisees() {
      let self = this;
      this.$firebase
        .firestore()
        .collection("regions")
        .where("id", "in", self.regionSupervisees)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            self.regions.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          console.log(self.regions);
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },

    deleteGroup(item) {
      let self = this;
      this.$confirm(
        "Voulez vous vraiment supprimer le  groupe <strong>" +
          item.nom_groupe +
          "</strong> ?, ses membres et ses différentes activités?"
      ).then((res) => {
        if (res) {
          self.deleteGroupeStore(item).then(() => {
            self.GetGroupesDeRegions();
          });
        }
      });
    },
    printFicheFormation(item) {
      let self = this;
      //get membres actifs
      self.SetItemById(item.id);
      self.GetMembresDuGroupe(item.id);

      this.$confirm(
        "Voulez vous vraiment imprimer une  fiche de formation du groupe <strong>" +
          item.nom_groupe +
          "</strong> ?"
      ).then((res) => {
        if (res) {
          console.log("printFicheFormation");
          var objectToSend = {
            membres: this.MembresDuGroupeActifs,
            request: this.request,
          };
          console.log("objectToSend*******", objectToSend);
          this.$router.push({
            name: "detailsGroupe-listeFormationsDeGroupe-print",
            params: objectToSend,
          });
        }
      });
    },

    printFicheDotation(item) {
      let self = this;
      //get membres actifs
      self.SetItemById(item.id);
      self.GetMembresDuGroupe(item.id);
      this.$confirm(
        "Voulez vous vraiment imprimer une  fiche de distribution du groupe <strong>" +
          item.nom_groupe +
          "</strong> ?"
      ).then((res) => {
        if (res) {
          var objectToSend = {
            membres: this.MembresDuGroupeActifs,
            request: this.request,
          };

          this.$router.push({
            name: "detailsGroupe-listeDotationsDeGroupe-print",
            params: objectToSend,
          });
        }
      });
    },
  },

  computed: {
    ...mapState({
      detailsGroupe: (state) => state.Groupes.itemById,
      user: (state) => state.Auth.user,
      //projets: (state) => state.Projets.projets,
      projets: (state) => state.Auth.user.projets,
      animateursDeRegions: (state) => state.Users.animateursDeRegions,
      animateursDeProjets(state) {
        return state.Users.animateursDeRegions.filter((u) => {
          const projets = Array.isArray(u.projets) ? u.projets : [];
          return projets.some((d) => _.includes(this.ProjetctList, d.id));
        });
      },
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      regionSupervisees: (state) => state.Utils.listeRegionsSupervisees,
      superviseurs: (state) =>
        _.filter(state.Users.identifiants, { role: "superviseur", active: 1 }),
      MembresDuGroupeActifs: (state) =>
        _.filter(state.Membres.MembresDuGroupe, { actif_dans_groupe: 1 }),
    }),
  },
};
</script>

<style lang="css" scoped>
.redPink {
  background-color: darksalmon;
}
.pink {
  background-color: darksalmon;
}
</style>
